// API configuration for the ticket payment widget

let API_BASE_URL_PLACEHOLDER = 'http://localhost:3000' // This will be replaced during build

// Remove any trailing slashes and ensure the URL is properly formatted
const formatUrl = (url) => {
  // If no URL provided, return the placeholder
  if (!url) return API_BASE_URL_PLACEHOLDER;

  try {
    // Try to create a URL object to validate the URL
    const urlObj = new URL(url);
    // Return the origin and pathname without trailing slash
    return `${urlObj.origin}${urlObj.pathname.replace(/\/$/, '')}`;
  } catch (e) {
    // If URL is invalid, return the formatted placeholder
    console.warn(`Invalid URL provided: ${url}, using default`);
    return API_BASE_URL_PLACEHOLDER;
  }
};

// Get the API URL from environment or use the placeholder
const envUrl = process.env.REACT_APP_API_URL;
const apiBaseUrl = formatUrl(envUrl);

export const config = {
  apiBaseUrl,
  isDefaultUrl: apiBaseUrl === API_BASE_URL_PLACEHOLDER
};
